import personalInfoApi from '../../../api/personalInfoApi'
import incomeWrite from '../../../api/consolidated-income-tax-statement/incomeWrite'
import {
  PERSONAL_DUTIES,
  CERTACILE_TYPE,
  PERSONAL_EDU,
  WORK_TYPE,
  YESORNO_TYPE,
  AUTHENTICATION_STATUS,
  SUBMISSION_STATUS
} from '../../../config/personal-income-tax'
import {MSG_MODES, MSG_TYPES, setMessage} from "../../../libs/message";
import NumberUtils from "../../../libs/utils/NumberUtils";
import UserPersistence from '../../../persistence/UserPersistence'

export const moduleId = "personal-info";
import {moduleId as salary} from "../consolidated-income-tax-statement";

export const state = {
  personnelDialog: false,
  detailDialog: false,
  platformDialog: false,
  tableData: [],
  id: '',
  type: "",//平台导入模块判断
  detailList: {},//详情
  currentPage: 1,  //当前要查询的页码
  pageSize: 10,  //每页显示记录数量
  totalPage: 0,
  allSize: 0,//总人数
  quitSize: 0,//本月离职
  entrySize: 0,//本月入职
  cityList: [],
  platFormList: [],//平台导入列表
  params: {
    sourceCode: null, //	登录唯一标识
    abId: null, //账套id（所属机构）
    operator: null,
    year: null, //所属年度
    month: null, ////所属月份

  },

  form: {
    employeeName: "",
    employeeNumber: "",
    employeeStatus: "",
    entryDateEnd: "",
    entryDateStart: "",
    entryType: "",
    idNumber: "",
    isAphrodite: "",
    isDisability: "",
    isLonesome: "",
    quitDateEnd: "",
    quitDateStart: "",
    sendStatus: "",
    sourceCode: "ceshi",
    taxNumber: "",
    updateDateEnd: "",
    updateDateStart: "",
    page: '',
    size: '',
  },
};

export const actions = {
  initView({state, commit, dispatch}) {
    // dispatch('GetPersonalInfo');
    dispatch("RegionInfo")
  },
  onCreate({state, commit, dispatch}, {to, from}) {
    // dispatch('GetPersonalInfo');
    dispatch('initView');
  },

  //首页列表

  async GetPersonalInfo({state, commit, dispatch}) {
    let query = {
      ...state.form,
      isGCL: state.form.isGCL && Number(state.form.isGCL),
      ...state.params,
      page: state.currentPage,
      size: state.pageSize,
    }
    let res = await personalInfoApi.GetPersonalInfo(query)
    if (res) {
      commit('setTableData', res.data.data.data);
      commit('setTotalPage', res.data.data);
    }
  },
  //导出
  async GetPersonal({state, commit, dispatch}, params) {
    // console.log(query)
    let query = {
      ids: params,
      ...state.params
    }
    let res = await personalInfoApi.GetPersonal(query)
    if (res) {
      // let blob = new Blob([res.data], {type: res.data.type})
      // const fileName = 'excel导出.xls';
      // let downloadElement = document.createElement('a')
      // let href = window.URL.createObjectURL(blob); //创建下载的链接
      // downloadElement.href = href;
      // downloadElement.download = fileName; //下载后文件名
      // document.body.appendChild(downloadElement);
      // downloadElement.click(); //点击下载
      // document.body.removeChild(downloadElement); //下载完成移除元素
      // window.URL.revokeObjectURL(href); //释放blob
      // commit('setTableData', res.data.data.data);
    }
  },
  //新增
  async SavePersonalInfo({state, commit, dispatch}, query) {
    // console.log(query)
    let params = {
      data: {
        ...query,
      },
      ...state.params
    }
    let res = await personalInfoApi.SavePersonalInfo(params)
    // if (res) {
    //     dispatch('GetPersonalInfo');
    //     commit('setPersonnelDialog',false)
    //     // commit('setTableData', res.data.data.data);
    // }
    if (!res.code) {
      dispatch('GetPersonalInfo');
      commit('setPersonnelDialog', false)
      setMessage({
        type: "success",
        message: '保存成功',
      });
    } else {
      setMessage({
        type: "error",
        message: res.msg,
      });
    }
  },
  //报送
  async SendPersonalInfo({state, commit, dispatch}, params) {
    // console.log(query)
    let query = {
      ...params,
      month: state.params.month,
      year: state.params.year
    }
    let res = await personalInfoApi.SendPersonalInfo(query)
    // if (res) {
    //     dispatch('GetPersonalInfo');
    //     // commit('setTableData', res.data.data.data);
    // }
    if (!res.code) {
      dispatch('GetPersonalInfo')
      // if (!params.m) {
      setMessage({
        type: "success",
        message: res.msg,
      });
      // } else if (!params.n) {
      //     setMessage({
      //         type: "error",
      //         message: '已报送无需报送',
      //     });
      // } else {
      //     setMessage({
      //         type: "success",
      //         message: `报送成功,其中${params.m}条已报送无需报送`,
      //     });
      // }
    } else {
      setMessage({
        type: "error",
        message: res.msg,
      });
    }
  },
  //修改
  async UpdatePersonalInfo({state, commit, dispatch}, query) {
    // console.log(query)
    let params = {
      data: {
        ...query,
        id: state.id
      },
      ...state.params

    }
    let res = await personalInfoApi.UpdatePersonalInfo(params)
    if (!res.code) {
      dispatch('GetPersonalInfo');
      commit('setDetailDialog', false)
      setMessage({
        type: "success",
        message: res.msg,
      });
    } else {
      setMessage({
        type: "error",
        message: res.msg,
      });
    }
  },
  //详情
  async getPersonalInfoDetail({state, commit, dispatch}, id) {
    commit("setDetailDialog", true)
    // console.log(query)
    let query = {
      ...state.form,
      ...state.params,
      id: id
    }
    let res = await personalInfoApi.getPersonalInfoDetail(query)
    if (res) {

      commit('setPersonalId', id);
      let data = res.data.data.data;
      // let obj = data.data.data
      let householdAddress = []
      let liveAddress = []
      let contactAddress = []
      let obj = Object.assign({}, {
        ...data,
        certificateType: data.certificateType,
        sex: data.sex + '',
        entryType: data.entryType && data.entryType + '',
        isDeductCost: data.isDeductCost + '',
        situation: data.situation ? data.situation + '' : '',
        bankProvince: data.bankProvince ? data.bankProvince.split('/') : '',
        personalMoney: Number(data.personalMoney).toFixed(2),
        investmentRatio: data.investmentRatio ? Number(data.investmentRatio).toFixed(4) : '',
        // householdAddress1
        // houseProvince: data.houseProvince ? data.houseProvince.split('/') : '',//户籍住址 省
        // houseCity: data.houseCity ? data.houseCity.split('/') : '',//户籍住址 市
        // houseAreavc: data.houseAreavc ? data.houseAreavc.split('/') : '',//区住址  区
        // liveAddress: data.liveAddress ? data.liveAddress.split('/') : '',//常驻地址
        // liveProvince: data.liveProvince ? data.liveProvince.split('/') : '',//居住 省
        // liveCity: data.liveCity ? data.liveCity.split('/') : '',//居住 市
        // liveArea: data.liveArea ? data.liveArea.split('/') : '',//居住 区
        // contactAddress: data.contactAddress ? data.contactAddress.split('/') : '',//联系地址
        // contactProvince: data.contactProvince ? data.contactProvince.split('/') : '',//联系地址省
        // contactCity: data.contactCity ? data.contactCity.split('/') : '',//联系地址市
        // contactArea: data.contactArea ? data.contactArea.split('/') : '',//联系地址区
        householdAddress1: householdAddress.concat(data.houseProvince, data.houseCity, data.houseArea),
        liveAddress1: liveAddress.concat(data.liveProvince, data.liveCity, data.liveArea),
        contactAddress1: contactAddress.concat(data.contactProvince, data.contactCity, data.contactArea),
      })
      // console.log(obj)
      commit('setDetailList', obj)
    }
  },
  //删除
  async delPersonalInfo({state, commit, dispatch}, params) {
    let query = {
      ids: params.arr,
      month: state.params.month,
      year: state.params.year
    }
    let res = await personalInfoApi.delPersonalInfo(query)
    if (!res.code) {
      dispatch('GetPersonalInfo')
      if (!params.m) {
        setMessage({
          type: "success",
          message: '删除成功',
        });
      } else if (!params.n) {
        setMessage({
          type: "error",
          message: '已报送无法删除',
        });
      } else {
        setMessage({
          type: "success",
          message: `删除成功,其中${params.m}条已报送无法删除`,
        });
      }
    } else {
      setMessage({
        type: "error",
        message: res.msg,
      });
    }
  },
  //省市区
  async RegionInfo({state, commit, dispatch}) {
    let res = await personalInfoApi.RegionInfo()
    if (res) {
      let data = res.data.data
      commit("setCityList", data)
    }
  },
  //平台导入模板列表
  async getEduFiles({state, commit, dispatch}, type) {
    commit("setType", type)
    let questionId = UserPersistence.getBaseInfo().user.qstId
    let openType = UserPersistence.getBaseInfo().user.openType
    let res = await personalInfoApi.getEduFiles({questionId, openType})
    if (!res.code) {
      let data = res.data
      commit("setPlatFormList", data)
    }
  },
  //综合所得申报  工资列表查询

  //平台模板人员导入
  async platForm({state, commit, dispatch}, url) {

  },
};

export const mutations = {
  setPersonnelDialog(state, falg) {
    state.personnelDialog = falg
  },
  setDetailDialog(state, falg) {
    state.detailDialog = falg
  },
  setPlatformDialog(state, falg) {
    state.platformDialog = falg
  },

  //当前页码设置
  setCurrentPage(state, data) {
    state.currentPage = data;
  },
  setPersonParams(state, params) {
    state.params = Object.assign({
      sourceCode: params.sourceCode, //	登录唯一标识
      abId: params.abId, //账套id（所属机构）
      operator: params.operator,
      year: params.year, //所属年度
      month: params.month, ////所属月份
    })
  },
  //当前页显示条数
  setPageSize(state, data) {
    state.pageSize = data;
  },
  setTableData(state, falg) {
    state.tableData = falg
  },
  //总条数
  setTotalPage(state, data) {
    state.totalPage = data.size
    state.allSize = data.allSize
    state.quitSize = data.quitSize
    state.entrySize = data.entrySize
  },
  //设置搜索条件
  setSearchForm(state, param) {
    state.form = Object.assign(state.form, param);
  },
  //设置id
  setPersonalId(state, id) {
    state.id = id
  },
  setDetailList(state, param) {
    state.detailList = param
  },
  //城市
  setCityList(state, data) {
    state.cityList = data
  },
  setType(state, data) {
    state.type = data
  },
  setPlatFormList(state, data) {
    state.platFormList = data
  }
};
export const getters = {
  tableDataTableGetter(state) {
    if (state.tableData.length > 0) {
      return state.tableData.map((item) => {
        return {
          ...item,
          sex: item.sex ? "女" : "男",
          isDisability: item.isDisability ? "是" : '否',
          isAphrodite: item.isAphrodite ? "是" : '否',
          isLonesome: item.isLonesome ? "是" : '否',
          entryType: item.entryType == 1 ? "雇员" : (item.entryType == 5 ? '其他' : ''),
          country: item.country && "中国",
          situation: item.situation == 1 ? "当年首次入职学生" : (item.situation == 2 ? "当年首次入职其他人员" : ''),
          employeeStatus: item.employeeStatus == 1 ? '正常' : (item.employeeStatus == 0 ? '非正常' : '')

        }
      })
    } else {
      return [];
    }
  }
}




// WEBPACK FOOTER //
// ./src/store/modules/personal-info/index.js